import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useRef, useEffect } from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../ui/accordion.js';
import { cn } from '../../lib/utils.js';

const AccordionUnder = ({
  openTitle = "알아두세요",
  closeTitle,
  children,
  isChangeTitle = false,
  direction = "top",
  className,
  defaultClose = false
}) => {
  const [active, setActive] = useState(true);
  const accordionRef = useRef(null);
  const [openItem, setOpenItem] = useState(void 0);
  const handleToggle = () => {
    setActive((prev) => !prev);
  };
  useEffect(() => {
    if (openItem && active && accordionRef.current) {
      setTimeout(() => {
        accordionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 0);
    }
  }, [active]);
  return /* @__PURE__ */ jsx("div", { ref: accordionRef, children: /* @__PURE__ */ jsx(
    Accordion,
    {
      type: "single",
      collapsible: true,
      variants: "under",
      direction,
      defaultValue: defaultClose ? void 0 : "item-1",
      className: cn("mt-20 [&+&]:mt-8", className),
      value: openItem,
      onValueChange: (value) => {
        setOpenItem(value);
      },
      children: /* @__PURE__ */ jsxs(AccordionItem, { value: "item-1", className: "border-none rounded-none", children: [
        /* @__PURE__ */ jsx(
          AccordionTrigger,
          {
            isChangeTitle,
            openTitle,
            closeTitle,
            onClick: handleToggle
          }
        ),
        /* @__PURE__ */ jsx(AccordionContent, { children })
      ] })
    }
  ) });
};

export { AccordionUnder };
